module.exports = __webpack_public_path__ + "img/anyETH.238811fc.svg";